import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { ListingCard } from "@/components/ListingCard";
import { Loading, Empty, ErrorState, PageTitle } from "@/components/States";
import { useToggleSave } from "@/pages/Browse";
import { btnPrimary } from "@/lib/ui";

export default function Saved() {
  const [items, setItems] = useState(null);
  const [err, setErr] = useState("");
  const toggle = useToggleSave(setItems);
  const load = useCallback(() => {
    setErr("");
    api.get("/saved").then(({ data }) => setItems(data)).catch((e) => setErr(errMsg(e)));
  }, []);
  useEffect(() => {
    load();
  }, [load]);
  const visible = items?.filter((i) => i.saved);
  return (
    <div>
      <PageTitle sub="Items you're keeping an eye on.">Saved</PageTitle>
      {err ? <ErrorState message={err} onRetry={load} /> : !items ? <Loading /> : visible.length === 0 ? (
        <Empty title="No saved items yet" body="Tap the heart on any listing to save it here." action={<Link to="/" className={btnPrimary}>Browse items</Link>} />
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-5">
          {visible.map((i) => <ListingCard key={i.id} item={i} onToggleSave={toggle} />)}
        </div>
      )}
    </div>
  );
}
